import moment from 'moment';
import { isEmpty } from 'lodash';
import { revertPhoneMask } from 'helpers/revert-phone-mask';
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from './axios.helpers';

export const getStaff = async (pageNumber, pageSize) =>
  axiosGet(`/staff?page[number]=${pageNumber + 1}&page[size]=${pageSize}`);

export const showStaff = async (id) => axiosGet(`/staff/${id}`);

export const updateStaff = async (id, staff) => {
  const {
    firstName,
    lastName,
    type,
    email,
    phone,
    address,
    city,
    state,
    postalCode,
    country,
    rate,
    mileageRate,
  } = staff;

  await axiosPatch(`/staff/${id}`, {
    first_name: firstName,
    last_name: lastName,
    type,
    email,
    address,
    city,
    state,
    postal_code: postalCode,
    country,
    rate,
    ...(isEmpty(phone) ? {} : { phone: revertPhoneMask(phone) }),
    ...(isEmpty(mileageRate) ? {} : { mileage_rate: mileageRate }),
  });
};

export const createStaff = async (staff) => {
  const {
    firstName,
    lastName,
    type,
    email,
    phone,
    address,
    city,
    state,
    postalCode,
    country,
    rate,
    mileageRate,
  } = staff;

  await axiosPost('/staff', {
    first_name: firstName,
    last_name: lastName,
    type,
    email,
    address,
    city,
    state,
    postal_code: postalCode,
    country,
    rate,
    ...(isEmpty(phone) ? {} : { phone: revertPhoneMask(phone) }),
    ...(isEmpty(mileageRate) ? {} : { mileage_rate: mileageRate }),
  });
};

export const deleteStaff = async (id) => {
  await axiosDelete(`/staff/${id}`);
};

export const getStaffAvailability = async (
  ids,
  startDate,
  endDate,
  startTime,
  endTime,
) => {
  const idFilters = ids.map((id) => `&filter[ids][]=${id}`).join('');
  const startDateFilter = `&filter[start_date]=${moment(startDate).format(
    'YYYY-MM-DD',
  )}`;
  const endDateFilter = `&filter[end_date]=${moment(endDate).format(
    'YYYY-MM-DD',
  )}`;
  const startTimeFilter = `&filter[start_time]=${moment(
    startTime,
    'hh:mm:ss',
  ).format('HH:mm')}`;
  const endTimeFilter = `&filter[end_time]=${moment(endTime, 'hh:mm:ss').format(
    'HH:mm',
  )}`;

  return axiosGet(
    `/staff-availability?${startDateFilter}${endDateFilter}${startTimeFilter}${endTimeFilter}${idFilters}`,
  );
};
